
// Animations
import './animations/fadeInOnScroll';
import './animations/smoothScroll';

//Functions
import './functions/headerScroll';
import './functions/swiper';

// Import main scss file here. This will compile to a css file in the dist folder
import '../scss/style.scss';

import './functions/navOverlay';
